export default __webpack_public_path__ + "static/media/MinimumCriticaly.3ea95597.svg";